import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { Reveal, SectionHead, EASE } from "./Reveal";

const CONDIZIONI = [
  "vuoi gestire la tua Partita IVA senza perderti nella burocrazia;",
  "desideri avere scadenze e adempimenti più chiari;",
  "vuoi trovare documenti e informazioni in un unico posto;",
  "non vuoi dipendere da email sparse e telefonate senza risposta;",
  "cerchi un contatto diretto con il professionista;",
  "preferisci un servizio digitale, ma non vuoi rinunciare al rapporto umano;",
  "vuoi concentrarti sul tuo lavoro con maggiore serenità.",
];

export default function PerChi() {
  return (
    <section id="per-chi" data-testid="section-per-chi" className="relative py-24 lg:py-32">
      <div className="pointer-events-none absolute left-[20%] top-0 h-[360px] w-[360px] rounded-full bg-[#19D6E8]/8 blur-[120px]" />
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHead
          eyebrow="Per chi è"
          align="center"
          title={
            <>
              Costruito intorno al regime forfettario: <span className="text-gradient">pensato per chi lavora in proprio</span>
            </>
          }
          sub="Human Factor è dedicato a freelance, liberi professionisti, lavoratori autonomi, artigiani, commercianti e ditte individuali che operano in regime forfettario. È particolarmente adatto a te se:"
        />

        <div className="mx-auto mt-14 grid max-w-5xl grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {CONDIZIONI.map((c, i) => (
            <motion.div
              key={c}
              data-testid={`per-chi-item-${i}`}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08, ease: EASE }}
              whileHover={{ y: -5 }}
              className={`glow-card flex h-full items-start gap-3.5 rounded-2xl p-5 ${i === CONDIZIONI.length - 1 ? "sm:col-span-2 lg:col-span-1" : ""}`}
            >
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[#1B6EF3] to-[#19D6E8] text-white">
                <Check className="h-3.5 w-3.5" />
              </span>
              <span className="text-sm leading-relaxed text-slate-200 sm:text-base">{c}</span>
            </motion.div>
          ))}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.6, delay: 0.24, ease: EASE }}
            className="flex h-full items-center justify-center gap-3 rounded-2xl bg-gradient-to-br from-[#1B6EF3] to-[#19D6E8] p-5 text-center shadow-lg shadow-blue-500/25"
            data-testid="per-chi-evidenza"
          >
            <span className="font-display text-base font-bold leading-snug text-white sm:text-lg">
              Human Factor è digitale dove serve e umano quando conta.
            </span>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
